
import { Component, ViewChild } from '@angular/core';
import { LoadingController, NavParams, ToastController, ViewController } from 'ionic-angular';
import { Rodeo } from '../../../../model/rodeo';
import { AlertMessager } from '../../../../lib/alertMessager';
import { StockGroup } from '../../../../model/stock-group';
import { RodeoEventRun } from '../../../../model/rodeoEventRun';
import { RunService } from '../../../../services/run.service';
import { Livestock } from '../../../../model/livestock';
import { RodeoEvent } from '../../../../model/rodeoEvent';

@Component({
    selector: 'stock-swap',
    templateUrl: 'stock-swap.component.html'
})
export class StockSwapPage {
    rodeo: Rodeo;
    rodeoEvent: RodeoEvent;
    run: RodeoEventRun;
    stockGroup: StockGroup;
    orderedStock: any[];

    loadingData: boolean;
    popoverActive: boolean;

    constructor(navParams: NavParams, private viewController: ViewController, private alert: AlertMessager, 
        private runService: RunService, private loadingControl: LoadingController, private toast: ToastController) {
        this.rodeo = navParams.get('rodeo');
        this.rodeoEvent = navParams.get("rodeoEvent");
        this.run = navParams.get('run');

        this.stockGroup = this.rodeo.stockGroups.filter(x => x.livestock.some(y => y.id == this.run.livestockId))[0];

        if (!this.stockGroup)
            this.stockGroup = this.rodeo.stockGroups[0];

        this.updateStock();
    }

    updateStock() {
        var runs = this.rodeoEvent.schedules.flatMap(x => x.runs);

        if (!this.stockGroup.livestock) {
            this.orderedStock = [];
            return;
        }

        this.stockGroup.livestock.forEach((livestock: any) => {
            livestock.runCount = runs.filter(x => x.livestockId == livestock.id).length;
        })

        this.orderedStock = this.stockGroup.livestock.sort((s1: any, s2: any) => {
            if (s1.runCount > s2.runCount)
                return 1;
            else if (s1.runCount < s2.runCount)
                return -1;
            else   
                return 0;
        });
    }

    selectStock(livestock) {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        this.run.livestock = livestock;
        this.run.livestockId = livestock.id;

        let loading = this.loadingControl.create({
            content: 'Updating Stock...',
        });

        loading.present();
        this.runService.updateRuns([this.run])
            .then(data => {
                loading.dismiss();
                this.popoverActive = false;
                this.toast.create({
                    message: 'Stock updated!',
                    duration: 3000,
                    position: 'middle',
                }).present();

                this.viewController.dismiss(data);
            }, error => {
                loading.dismiss();
                this.popoverActive = false;
                this.alert.showError("Stock Update Error", error);
            })
    }

    cancel() {
        this.viewController.dismiss();
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/scoring/stock-swap.component.ts